import {useTranslation} from 'react-i18next';

import {InlineError, ConfirmActionModal} from '@/components';

import type {FC} from 'react';

export interface DeleteBuyerModalProps {
  /** Buyer display name to include in the confirmation message; null means the modal is closed. */
  buyerName: string | null;
  onConfirm: () => void;
  onClose: () => void;
  isLoading?: boolean;
  error?: unknown;
}

export const DeleteBuyerModal: FC<DeleteBuyerModalProps> = ({
  buyerName,
  onConfirm,
  onClose,
  isLoading = false,
  error
}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <ConfirmActionModal
      isOpen={buyerName !== null}
      headerAlign="start"
      title={t('view.buyers.detail.deleteBuyer.title')}
      description={t('view.buyers.detail.deleteBuyer.description', {name: buyerName})}
      confirmLabel={t('view.buyers.detail.deleteBuyer.confirmLabel')}
      onConfirm={onConfirm}
      onClose={onClose}
      isLoading={isLoading}
    >
      {error != null && <InlineError error={error} />}
    </ConfirmActionModal>
  );
};
